<template>
    <div class="card p-3 h-100 shadow-sm border border-light" :class="[
        person.hasObligation === false ? 'bg-light text-muted' : '',
        person.hasObligation === true ? 'clickable' : ''
    ]" @click="person.hasObligation && $emit('open-pre-court', person)">
        <div class="d-flex justify-content-between align-items-center mb-0">
            <h6 class="text-dark d-flex align-items-center gap-2 mb-0">
                <i class="fa fa-user text-secondary me-2"></i>
                {{ person.personType === 1 ? 'Fiziki şəxs' : 'Hüquqi şəxs' }}
            </h6>

            <el-switch :model-value="person.hasObligation" @change="onSwitchChange" @click.stop :active-value="true"
                :inactive-value="false" :disabled="lastStatus === 50" active-text="Öhdəlik var"
                inactive-text="Öhdəlik yoxdur" inline-prompt size="large"
                style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />

        </div>

        <hr style="margin-top: 8px;" />

        <div class="row" style="color: #606266; font-size: 14px;">
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">A.S.A:</span>
                {{ person.name }} {{ person.surname }} {{ person.fatherName }}
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">Ad:</span> {{ person.name }}
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">FİN:</span> {{ person.pin }}
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">VÖEN:</span> {{ person.tin }}
            </div>
            <div v-if="person.personType === 2" class="col-md-6 mb-2">
                <span class="font-weight-bold">Nümayəndə:</span> {{ person.representative }}
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">Cins:</span>
                {{ person.gender === 1 ? 'Kişi' : person.gender === 2 ? 'Qadın' : '' }}
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">Doğum tarixi:</span> {{ formatDate(person.birthDate) }}
            </div>
            <div class="col-md-6 mb-2">
                <span class="font-weight-bold">Nömrə:</span> {{ person.phone }}, {{ person.additionalPhone }}
            </div>
            <div v-if="person.personType === 1" class="col-md-6 mb-2">
                <span class="font-weight-bold">İş yeri:</span> {{ person.workPlace }}
            </div>
            <div class="col-md-6 mb-2">
                <span class="font-weight-bold">Faktiki yaşayış ünvanı:</span> {{ person.regAddress }}
            </div>
            <div v-if="obligation.has && obligation.amount" class="col-md-6 mb-2">
                <span class="font-weight-bold">Öhdəlik məbləği (AZN):</span> {{ formatAmount(obligation.amount) }}
            </div>
        </div>
    </div>
</template>

<script>
import { LastParticipantStatus } from "@/project/Source/participants";
import { UpdateCourtParticipant } from "@/project/Source/courtparticipants";

export default {
    props: {
        isExecutorView: Boolean,
        person: Object,
        obligation: {
            type: Object,
            default: () => ({ has: null, amount: null })
        }
    },
    data() {
        return {
            lastStatus: null
        };
    },
    mounted() {
        this.getLastParticipantStatus();
    },
    methods: {
        formatAmount(value) {
            if (value == null) return "-";
            let parts = Number(value).toFixed(2).split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(",");
        },
        formatDate(dateString) {
            if (!dateString) return "—";
            const date = new Date(dateString);
            return date.toLocaleDateString("az-AZ");
        },
        async getLastParticipantStatus() {
            try {
                const res = await LastParticipantStatus(this.person.id);
                this.lastStatus = res.data.data;
            } catch (err) {
                console.error("Status yüklənmədi:", err);
            }
        },
        async onSwitchChange(value) {
            try {
                await UpdateCourtParticipant({
                    id: this.person.id,
                    name: this.person.name,
                    surname: this.person.surname,
                    fathername: this.person.fatherName,
                    pin: this.person.pin,
                    persontype: this.person.personType,
                    gender: this.person.gender,
                    birthdate: this.person.birthDate,
                    phone: this.person.phone,
                    additionalphone: this.person.additionalPhone,
                    workplace: this.person.workPlace,
                    regaddress: this.person.regAddress,
                    representative: this.person.representative,
                    tin: this.person.tin,
                    courtcaseid: this.person.courtCaseId,
                    user: this.$store.state.user.id,
                    hasObligation: value
                });

                this.$emit("obligation-updated");
            } catch (error) {
                console.error("Öhdəlik saxlanılmadı:", error);
                this.$message.error("Xəta baş verdi!");
            }
        }
    }
};
</script>

<style scoped>
.clickable {
    cursor: pointer;
}
</style>
